import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
  {
    variants: {
      tone: {
        // ink-soft, not ink-muted: muted on surface-muted measures 4.34:1, below the 4.5:1
        // WCAG 1.4.3 floor for this text size; ink-soft on the same pill measures 13.3:1
        // while keeping the subdued grey pill. Surfaced by the e2e axe scan.
        neutral: "bg-surface-muted text-ink-soft",
        info: "bg-primary-50 text-primary-700",
        success: "bg-accent-50 text-accent-700",
        warning: "bg-amber-50 text-warning",
        danger: "bg-red-50 text-danger",
        inverse: "bg-white/10 text-white",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
